export var arrowKeys = {
  ArrowDown: 'down',
  ArrowLeft: 'left',
  ArrowRight: 'right',
  ArrowUp: 'up'
};
export var daysPerWeek = 7;
export var monthsPerYear = 12;
export var blankStringArray = [];